/**
 * Web Vitals tracking
 * Monitors Core Web Vitals metrics for performance analysis
 */

import { onCLS, onFCP, onLCP, onTTFB, onINP } from 'web-vitals';
import type { Metric } from 'web-vitals';
import { logger } from './logger';

const isDevelopment = import.meta.env.MODE === 'development';

/**
 * Send metrics to analytics service
 * In development, logs to console
 * In production, you can send to your analytics service (e.g., Google Analytics, Sentry)
 */
function sendToAnalytics(metric: Metric) {
  if (isDevelopment) {
    logger.info('📊 Web Vital:', {
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      delta: metric.delta,
      id: metric.id,
    });
  }

  // TODO: In production, send to your analytics service
  // Example for Google Analytics:
  // if (window.gtag) {
  //   window.gtag('event', metric.name, {
  //     value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
  //     event_category: 'Web Vitals',
  //     event_label: metric.id,
  //     non_interaction: true,
  //   });
  // }

  // Example for custom analytics:
  // fetch('/api/analytics', {
  //   method: 'POST',
  //   body: JSON.stringify(metric),
  //   headers: { 'Content-Type': 'application/json' },
  // });
}

/**
 * Initialize Web Vitals tracking
 * Call this function once when your app starts
 */
export function initWebVitals() {
  // Cumulative Layout Shift - measures visual stability
  onCLS(sendToAnalytics);

  // Interaction to Next Paint - measures interactivity (replaces FID)
  onINP(sendToAnalytics);

  // First Contentful Paint - measures loading performance
  onFCP(sendToAnalytics);

  // Largest Contentful Paint - measures loading performance
  onLCP(sendToAnalytics);

  // Time to First Byte - measures server response time
  onTTFB(sendToAnalytics);

  if (isDevelopment) {
    logger.info('✅ Web Vitals tracking initialized');
  }
}

